<template>
  <div class="buy-view">
    <site-menu theme="dark" class="menu"/>
    <div class="inner">
      <iframe
        class="iframe"
        src="https://wannago.show/www/wa/instance?id=50&k=aocgp1wsor4wy059udrw80cgw3a5jb&e=WNGInstance"
      />
    </div>
  </div>
</template>

<script>
  import SiteMenu from '@/components/SiteMenu.vue'

  export default {
    name: 'buy-view',
    components: { SiteMenu },
    data() {
      return {
      }
    },
    methods: {
    },
  }
</script>
<style scoped lang="scss">
  .buy-view {
    position: relative;
  }
  .iframe {
    width: 100%;
    height: 800px;
    margin-top: 4px;
    border: 0;    
  }
  @media (max-width: 500px) {
    .iframe {
      margin-top: 40px;
    }
  }

</style>